import { Container, Title } from '@mantine/core'
import Seo from '../_Seo'

// Shared shell for static content pages. Renders the raw semantic HTML
// (h2/p/ul/a) with browser defaults — wireframe level, to be themed in the
// design phase.
export default function StaticPage({ title, description, children }) {
  return (
    <>
      <Seo title={title} description={description} />
      <Container size="sm" py="xl">
        <Title order={1} mb="lg">
          {title}
        </Title>
        {children}
      </Container>
    </>
  )
}
